export interface SalaryRow {
  user_id: string;
  cleaner_name: string | null;
  kr_per_point: number | null;
  points: number;
  kr: number;
  pending_points: number;
  pending_kr: number;
  paid_points: number;
  paid_kr: number;
  entries: unknown[];
}

export interface SalaryTotals {
  points: number;
  kr: number;
  pending_kr: number;
  paid_kr: number;
  cleaners: number;
}

export interface SalaryResponse {
  rows: SalaryRow[];
  totals: SalaryTotals;
}

function safeParse(text: string): unknown {
  try {
    return JSON.parse(text);
  } catch {
    return text;
  }
}

export async function fetchSalary(
  from: string,
  to: string,
  sessionToken: string | null,
): Promise<SalaryResponse> {
  const qs = new URLSearchParams({ from, to });
  const headers = new Headers({ 'Content-Type': 'application/json' });
  if (sessionToken) headers.set('Authorization', `Bearer ${sessionToken}`);

  const res = await fetch(`/api/ops/salary?${qs.toString()}`, { headers });
  const rawText = await res.text();
  const parsed = rawText ? safeParse(rawText) : null;

  if (!res.ok) {
    const msg =
      typeof parsed === 'object' && parsed !== null && 'error' in parsed
        ? String((parsed as Record<string, unknown>).error)
        : `${res.status} ${res.statusText}`;
    throw new Error(msg);
  }

  return parsed as SalaryResponse;
}
